import Spade from "@/components/Spade";

export default function Divider({ label = "" }) {
    return (
        <div className="flex items-center justify-center gap-4 py-16 opacity-90 select-none">
            <span className="h-px w-16 md:w-24 bg-gradient-to-r from-transparent via-[var(--accent-gold)] to-transparent" />
            <Spade size={22} />
            {label ? (
                <span className="font-fraktur text-[var(--accent-gold)] text-lg md:text-xl tracking-[0.2em]">
                    {label}
                </span>
            ) : null}
            <Spade size={22} />
            <span className="h-px w-16 md:w-24 bg-gradient-to-r from-transparent via-[var(--accent-gold)] to-transparent" />
        </div>
    );
}
